import React, { useContext, useState, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";
import OTPVerification from "../pages/OTP Verification";
import GSTVerification from "../pages/GST Verification";
import GSTDetails from "../pages/GST Details";
import BusinessType from "../pages/BusinessType";
import OwnerKYC from "../pages/OwnerKYC";
import DriverKYC from "../pages/DriverKYC";
import VerifiedKYC from "../pages/OwnerKYC/verifiedKYC";
import VerifiedDriverKYC from "../pages/DriverKYC/verifiedDriverKYC";
import NoInternet from "../pages/NoInternet";
import { TokenContext } from "../service/context/tokencontent";
import Loading from "../components/Loading/Loading";
import useNetworkStatus from "../service/useNetworkStatus";
import ConfirmPassword from "../pages/ConfirmPassword/ConfirmPassword";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ForgotOtpVerification from "../pages/OTP Verification/ForgotPassword";
import MobileOTPVerification from "../pages/OTP Verification/MobileOTPVerification";
import TermsAndConditions from "../pages/Policies/TermsAndConditions";
import PrivacyPolicy from "../pages/Policies/PrivacyPolicy";
import CancellationAndRefund from "../pages/Policies/CancellationAndRefund";
import ShippingAndDelivery from "../pages/Policies/ShippingAndDelivery";
const PublicRoutes = () => {
  const isOnline = useNetworkStatus();
  const [isLoading, setIsLoading] = useState(true);
  const tokenContext = useContext(TokenContext);
  const token = tokenContext?.token;
  const location = useLocation();
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  

  if (isLoading) return <Loading />;

  return (
    <Routes>
      <Route path="/" element={<Navigate replace to={token ? "/dashboard" : "/login"} />} />
      <Route path="/login" element={<Login />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/cancellation&refund" element={<CancellationAndRefund />} />
      <Route path="/shipping&delivery" element={<ShippingAndDelivery />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/otp-verfication" element={<OTPVerification />} />
      <Route path="/gst-verfication" element={<GSTVerification />} />
      <Route path="/gst-details" element={<GSTDetails />} />
      <Route path="/businesstype" element={<BusinessType />} />
      <Route path="/owner-kyc" element={<OwnerKYC />} />
      <Route path="/verified/owner-kyc" element={<VerifiedKYC />} />
      <Route path="/driver-kyc" element={<DriverKYC />} />
      <Route path="/verified/driver-kyc" element={<VerifiedDriverKYC />} />
      <Route path="*" element={<Navigate replace to={token ? "/dashboard" : "/login"} />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/confirmpassword" element={<ConfirmPassword/>} />
      <Route path="/mobile-otpverfication" element={<MobileOTPVerification/>} />
      <Route path="/forgototpverfication" element={<ForgotOtpVerification />} />


      {/* Add more public routes here */}
    </Routes>
  );
};

export default PublicRoutes;
